<template>
<div>

<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>


</div>

</template>

<script>

import { mapGetters } from 'vuex';


import alertBox          from '@/components/common/AlertBox.vue'

//import api            from '@/api'

  export default {
  props : ['data','giftTicket'],

     components: {alertBox},
    data () {
      return {
        

        
          msg      : {title : '',body:'',type :0},
          cmd      : ''
          
        
        
      }
    },

    

    computed: {
     ...mapGetters(['company']),

    },
      
    methods: 
    {
     
    
     cmdData ()
     {   
         
        

         let total_discount = 0
        
         let cmd            = 'data:text/csv;charset=utf-8,'
         let cr             = "\r\n"
              
        if(this.data.data)
         {
            
            cmd += '1322' + cr
            let total_row = 0
            this.data.data[0].forEach(item => {
             
                total_discount = item.total_discount
                total_row = item.total_row
                if(item.rowType == 1)
                {
                    total_row = total_row * -1
                }
                cmd += "1325;" + total_row.toString().replace('.',',') + ";" +  item.barcode + " " + item.category + ";1" + cr
                                
            });
            cmd += '1332' + cr
            if(total_discount)
                {
                    cmd += '1326;' + total_discount.toString().replace('.',',')  + cr
                }

                this.data.data[1].forEach(item => {
                    let payment = 1
                    if(item.typeId == 'ELEC')
                    {
                        payment = 4
                    }
                    else if(item.typeId == 'CASH' )
                    {
                        payment = 1
                    }

                    cmd += '1329;' + item.total.toString().replace('.',',') + ';' + payment  + cr    
                })
                
                
                cmd += '1323' + cr
                cmd += '1029' + cr
            
         }


        this.cmd = cmd
        return this.cmd
     },

    
     clickHandler() {
            
                if(this.giftTicket)
                {
                    this.$emit('finish')
                    return
                }

                let cmd = this.cmdData()
                var encodedUri = encodeURI(cmd)
                var link = document.createElement("a")
                link.setAttribute("href", encodedUri)
                link.setAttribute("download", "sco.txt")
                link.click()    
                
                this.$emit('finish')
        
           

           

           
      
        }
  
      

    }
  }
</script>
<style scoped>

 


</style>
